import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { AppImage, brandclub_colors, useStacklineTheme } from '@stackline/ui';

export const SearchTextField = (props: TextFieldProps) => {
  const theme = useStacklineTheme();

  return (
    <TextField
      variant="standard"
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <AppImage
            src="/svg/icons/search.svg"
            alt="search-icon"
            style={{
              marginRight: 8,
              height: 16,
              width: 16,
            }}
          />
        ),
        autoComplete: 'off',
        id: 'type-search'
      }}
      sx={{
        borderRadius: 17,
        border: `1px solid ${theme.colors.primaryGray}`,
        padding: '5px 14px',
        width: 'fit-content',
        backgroundColor: brandclub_colors.white,
        '& div.MuiInput-root': {
          display: 'flex',
          alignItems: 'center',
          height: '20px',
          boxSizing: 'content-box',
          width: '260px',
          '& input': {
            padding: 0,
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            color: theme.colors.primary
          }
        },
        '& .MuiInput-input::placeholder': {
          color: '#BEC7D3',
          fontSize: '14px',
          opacity: 1,
          fontWeight: 400
        },
        // Ensure placeholder color stays consistent when disabled
        '& .MuiInput-root.Mui-disabled': {
          '& .MuiInput-input::placeholder': {
            color: '#BEC7D3',
            opacity: 1,
            WebkitTextFillColor: '#BEC7D3'
          },
          '& .MuiInput-input': {
            WebkitTextFillColor: '#BEC7D3'
          }
        },
        '& .Mui-disabled .MuiInput-input::placeholder': {
          color: '#BEC7D3',
          opacity: 1,
          WebkitTextFillColor: '#BEC7D3'
        },
        '& .Mui-disabled .MuiInput-input': {
          WebkitTextFillColor: '#BEC7D3'
        }
      }}
      {...props}
    />
  );
};
